/**
 * An Enum providing default values for timeouts to pass on to the debounce function for various use-cases.
 */
export const enum DebounceDelays {
  Resize = 200,
  Scroll = 50,
}
